import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana65Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_22578)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M381.881 526.348L424.243 500.562L466.605 572.394C457.396 576.077 436.767 583.076 427.926 581.603C419.086 580.129 411.964 577.305 409.508 576.077C387.406 565.763 381.881 538.627 381.881 526.348Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M516.343 559.497C501.609 559.497 477.051 568.093 466.614 572.39L426.094 500.559L466.614 476.615L516.343 559.497Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M549.488 557.661C538.284 557.661 524.93 558.275 516.335 559.503L466.605 476.621L503.442 454.52L560.539 552.136C559.311 554.592 556.855 557.661 549.488 557.661Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M582.644 506.085L560.542 552.131L503.445 454.514L542.124 432.412L582.644 506.085Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M619.476 417.678L582.639 507.928L542.119 432.413L599.355 396.64C600.468 395.945 601.761 395.557 603.071 395.633C620.289 396.635 621.251 410.578 619.476 417.678Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_22578"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_22578"
            transform="matrix(0.00252637 0 0 0.00334929 -3.35429 -3.39689)"
          />
        </pattern>
        <image
          id="image0_1466_22578"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
